import React, { createContext, useContext, useState, useEffect } from "react";
import { setUnauthorizedHandler } from "../api";

interface AdminContextType {
  token: string | null;
  login: (token: string) => void;
  logout: () => void;
  isAdmin: boolean;
}

const AdminContext = createContext<AdminContextType | null>(null);
const STORAGE_KEY = "ks_admin_token";

export const AdminProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) setToken(saved);
    } catch {}
  }, []);

  const login = (t: string) => {
    setToken(t);
    try {
      localStorage.setItem(STORAGE_KEY, t);
    } catch {}
  };

  const logout = () => {
    setToken(null);
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch {}
  };

  useEffect(() => {
    setUnauthorizedHandler(logout);
    return () => setUnauthorizedHandler(null);
  }, []);

  return (
    <AdminContext.Provider value={{ token, login, logout, isAdmin: !!token }}>
      {children}
    </AdminContext.Provider>
  );
};

export const useAdmin = (): AdminContextType => {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error("useAdmin must be used inside AdminProvider");
  return ctx;
};
